import { history } from 'store';
import { initWoopraCustomEvents } from './woopraCustomEvents';

export const initWoopra = woopraDomain => {
  if (woopraDomain) {
    !(function() {
      var t,
        o,
        c,
        e = window,
        n = document,
        r = arguments,
        a = 'script',
        i = [
          'call',
          'cancelAction',
          'config',
          'identify',
          'push',
          'track',
          'trackClick',
          'trackForm',
          'update',
          'visit',
        ],
        s = function() {
          var t,
            o = this,
            c = function(t) {
              o[t] = function() {
                return o._e.push([t].concat(Array.prototype.slice.call(arguments, 0))), o;
              };
            };
          for (o._e = [], t = 0; t < i.length; t++) c(i[t]);
        };
      for (e.__woo = e.__woo || {}, t = 0; t < r.length; t++) e.__woo[r[t]] = e[r[t]] = e[r[t]] || new s();
      ((o = n.createElement(a)).async = 1),
        (o.src = 'https://static.woopra.com/js/w.js'),
        (c = n.getElementsByTagName(a)[0]).parentNode.insertBefore(o, c);
    })('woopra');

    // eslint-disable-next-line no-undef
    woopra &&
      // eslint-disable-next-line no-undef
      woopra.config({
        domain: woopraDomain,
        outgoing_tracking: false,
        download_tracking: false,
        click_tracking: false,
      });

    initWoopraCustomEvents();

    const pathnamesToTrack = ['/search', '/booking-builder', '/pure-ai'];

    const shouldTrack = pathname => pathnamesToTrack.some(x => pathname.startsWith(x));

    const track = () =>
      // eslint-disable-next-line no-undef
      woopra && shouldTrack(history.location.pathname) && woopra.track();

    track();
    history.listen(track);
  }
};
